import { render, staticRenderFns } from "./OrderToModify.vue?vue&type=template&id=7190aca1&scoped=true&"
import script from "./OrderToModify.vue?vue&type=script&lang=js&"
export * from "./OrderToModify.vue?vue&type=script&lang=js&"
import style0 from "./OrderToModify.vue?vue&type=style&index=0&id=7190aca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7190aca1",
  null
  
)

export default component.exports